/*
 *  Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import {
  APPLICATION_STATUS_ACCIDENT_BASE,
  APPLICATION_STATUS_DAMAGE,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_DONE,
  APPLICATION_STATUS_INSURANCE,
  APPLICATION_STATUS_OPPOSING_PARTY,
  APPLICATION_STATUS_POWER_OF_ATTORNEY,
  APPLICATION_STATUS_SUMMARY
} from "./applicationStatus";
import React from "react";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import progressBarSteps from "./progressBarSteps";
import { getCaseLink } from "../productService";
import { Navigate } from "react-router";
import { FormSteps } from "../../types/FormServiceBase";
import AccidentBase from "../../components/Form/TrafficAccident/AccidentBase";
import OpposingParty from "../../components/Form/TrafficAccident/OpposingParty";
import DamageDetails from "../../components/Form/TrafficAccident/DamageDetails";
import Insurance from "../../components/Form/Common/Insurance/Insurance";
import SummaryHintBox from "../../components/Form/Common/SummaryHintBox";
import Summary from "../../components/Form/TrafficAccident/Summary";
import PowerOfAttorneyIntroHintBox from "../../components/Form/TrafficAccident/PowerOfAttorneyIntroHintBox";
import PowerOfAttorney from "../../components/Form/LitigationCase/PowerOfAttorney";
import PowerOfAttorneyIntroHighlightBox from "../../components/Form/TrafficAccident/PowerOfAttorneyIntroHighlightBox";
import { DocumentsForm } from "../../components/Form/DocumentsForm/DocumentsForm";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_ACCIDENT_BASE]: {
    title: "Antrag - Unfall | Legalbird",
    stepUrl: "unfall",
    applicationStatus: APPLICATION_STATUS_ACCIDENT_BASE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"accident"} progress={16} />
        <AccidentBase {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_OPPOSING_PARTY]: {
    title: "Antrag - Unfallgegner | Legalbird",
    stepUrl: "unfallgegner",
    applicationStatus: APPLICATION_STATUS_OPPOSING_PARTY,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"accusation"} progress={33} />
        <OpposingParty {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DAMAGE]: {
    title: "Antrag - Beschädigungen | Legalbird",
    stepUrl: "schaden",
    applicationStatus: APPLICATION_STATUS_DAMAGE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"damage"} progress={46} />
        <DamageDetails {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INSURANCE]: {
    title: "Antrag - Versicherung | Legalbird",
    stepUrl: "versicherung",
    applicationStatus: APPLICATION_STATUS_INSURANCE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"damage"} progress={66} />
        <Insurance withDeductible {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DOCUMENTS]: {
    title: "Antrag - Dokumente | Legalbird",
    stepUrl: "dokumente",
    applicationStatus: APPLICATION_STATUS_DOCUMENTS,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"documents"} progress={66} />
        <DocumentsForm product={props.product} submitProps={props.submitProps} />
      </>
    ),
  },
  [APPLICATION_STATUS_SUMMARY]: {
    title: "Antrag - Überprüfen | Legalbird",
    stepUrl: "ueberpruefen",
    applicationStatus: APPLICATION_STATUS_SUMMARY,
    render: (props) => (
      <>
        <SummaryHintBox />
        <Summary {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_POWER_OF_ATTORNEY]: {
    title: "Antrag - Vollmacht | Legalbird",
    stepUrl: "vollmacht",
    applicationStatus: APPLICATION_STATUS_POWER_OF_ATTORNEY,
    render: (props) => (
      <>
        <PowerOfAttorneyIntroHintBox {...props} />
        <PowerOfAttorney {...props} SignatoryHighlightBox={null} OutroHighlightBox={PowerOfAttorneyIntroHighlightBox} />
      </>
    ),
  },
  [APPLICATION_STATUS_DONE]: {
    title: "Mein Fall | Legalbird",
    stepUrl: "done",
    applicationStatus: APPLICATION_STATUS_DONE,
    render: (props) => <Navigate to={getCaseLink(props.product)} />,
  },
};

export default formSteps;
